import { render, staticRenderFns } from "./FormContentPhotoComponent.vue?vue&type=template&id=a6495f30&scoped=true"
import script from "./FormContentPhotoComponent.vue?vue&type=script&lang=js"
export * from "./FormContentPhotoComponent.vue?vue&type=script&lang=js"
import style0 from "./FormContentPhotoComponent.vue?vue&type=style&index=0&id=a6495f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6495f30",
  null
  
)

export default component.exports